export default __webpack_public_path__ + "static/media/plan-icon.84bb877a.svg";